<section class="component component--content">
	<div class="wrapper">
		<div class="row">
			<div class="col-12 col-md-9">
				<div class="content_wrapper" *ngIf="'none' != newsContent.scb_link_type">
					<a routerLink="{{ newsContent.scb_link.url }}" class="news__link" target="{{ newsContent.scb_link.target }}" *ngIf="'internal' == newsContent.scb_link_type">
						<div class="figure-type out_of_boundary">
							<figure id="out_of_boundary" class="image-type out_of_boundary" *ngIf="newsContent.scb_image != '' && !isMobile">
								<img src="{{ newsContent.scb_image.url }}" alt="{{ newsContent.scb_image.title }}" class="img-responsive" loading="lazy" />
								<p *ngIf="newsContent.scb_image.caption != ''" [innerHtml]="newsContent.scb_image.caption | safe:'preamble'" class="img-caption"></p>
							</figure>
							<figure id="out_of_boundary" class="image-type out_of_boundary" *ngIf="newsContent.scb_image != '' && isMobile">
								<img src="{{ newsContent.scb_image.sizes.medium_large }}" alt="{{ newsContent.scb_image.title }}" class="img-responsive" loading="lazy" />
								<p *ngIf="newsContent.scb_image.caption != ''" [innerHtml]="newsContent.scb_image.caption | safe:'preamble'" class="img-caption"></p>
							</figure>
						</div>
						<div class="tab-title__col">
							<h2 class="tab__title"></h2>
						</div>
						<div class="entry-content" *ngIf="newsContent.scb_sub_title"><h2 [innerHtml]="newsContent.scb_sub_title"></h2></div>
						<div class="entry-content" *ngIf="newsContent.scb_content != ''" [innerHtml]="newsContent?.scb_content"></div>
					</a>
					<a href="{{ newsContent.scb_link_ext }}" class="news__link" target="_blank" *ngIf="'external' == newsContent.scb_link_type">
						<div class="figure-type out_of_boundary">
							<figure id="out_of_boundary" class="image-type out_of_boundary" *ngIf="newsContent.scb_image != '' && !isMobile">
								<img src="{{ newsContent.scb_image.url }}" alt="{{ newsContent.scb_image.title }}" class="img-responsive" loading="lazy" />
								<p *ngIf="newsContent.scb_image.caption != ''" [innerHtml]="newsContent.scb_image.caption | safe:'preamble'" class="img-caption"></p>
							</figure>
							<figure id="out_of_boundary" class="image-type out_of_boundary" *ngIf="newsContent.scb_image != '' && isMobile">
								<img src="{{ newsContent.scb_image.sizes.medium_large }}" alt="{{ newsContent.scb_image.title }}" class="img-responsive" loading="lazy" />
								<p *ngIf="newsContent.scb_image.caption != ''" [innerHtml]="newsContent.scb_image.caption | safe:'preamble'" class="img-caption"></p>
							</figure>
						</div>
						<div class="tab-title__col">
							<h2 class="tab__title"></h2>
						</div>
						<div class="entry-content" *ngIf="newsContent.scb_sub_title"><h2 [innerHtml]="newsContent.scb_sub_title"></h2></div>
						<div class="entry-content" *ngIf="newsContent.scb_content != ''" [innerHtml]="newsContent?.scb_content"></div>
					</a>
				</div>
				<div class="content_wrapper" *ngIf="'none' == newsContent.scb_link_type">
					<div class="figure-type out_of_boundary">
						<figure id="out_of_boundary" class="image-type out_of_boundary" *ngIf="newsContent.scb_image != '' && !isMobile">
							<img src="{{ newsContent.scb_image.url }}" alt="{{ newsContent.scb_image.title }}" class="img-responsive" loading="lazy" />
							<p *ngIf="newsContent.scb_image.caption != ''" [innerHtml]="newsContent.scb_image.caption | safe:'preamble'" class="img-caption"></p>
						</figure>
						<figure id="out_of_boundary" class="image-type out_of_boundary" *ngIf="newsContent.scb_image != '' && isMobile">
							<img src="{{ newsContent.scb_image.sizes.medium_large }}" alt="{{ newsContent.scb_image.title }}" class="img-responsive" loading="lazy" />
							<p *ngIf="newsContent.scb_image.caption != ''" [innerHtml]="newsContent.scb_image.caption | safe:'preamble'" class="img-caption"></p>
						</figure>
					</div>
					<div class="tab-title__col">
						<h2 class="tab__title"></h2>
					</div>
					<div class="entry-content" *ngIf="newsContent.scb_sub_title"><h2 [innerHtml]="newsContent.scb_sub_title"></h2></div>
					<div class="entry-content" *ngIf="newsContent.scb_content != ''" [innerHtml]="newsContent?.scb_content | safe:'preamble'"></div>
				</div>
			</div>
			<div class="col-12 col-md-3">
				<div class="content__sidebar" *ngIf="newsContent.scb_sb_image != '' || newsContent.scb_sb_heading != '' || newsContent.scb_sb_content != '' || newsContent.scb_sb_link != ''">
					<a href="{{ newsContent.scb_sb_link.url }}" class="news__link" target="{{ newsContent.scb_sb_link.target }}">
						<figure *ngIf="newsContent.scb_sb_image != ''">
							<img src="{{ newsContent.scb_sb_image.url }}" alt="{{ newsContent.scb_sb_image.title }}" class="img-responsive" loading="lazy" />
							<p *ngIf="newsContent.scb_sb_image.caption != ''" [innerHtml]="newsContent.scb_sb_image.caption | safe:'preamble'" class="img-caption"></p>
						</figure>
						<div class="besides-figure entry-content" *ngIf="newsContent.scb_sb_heading != '' || newsContent.scb_sb_content != '' || newsContent.scb_sb_link.url != ''">
							<h4 *ngIf="newsContent.scb_sb_heading != ''" [innerHtml]="newsContent.scb_sb_heading"></h4>
							<div *ngIf="newsContent.scb_sb_content != ''" [innerHtml]="newsContent.scb_sb_content"></div>
							<p class="btn-wrapper" *ngIf="newsContent.scb_sb_link.url != ''"><span class="link-span btn btn-bluelight btn-circle"><span>{{ newsContent.scb_sb_link.title }}</span> <i class="icon-arrow-right"></i></span></p>
						</div>
					</a>
				</div>
			</div>
		</div>
	</div>
</section>